module.exports = __webpack_public_path__ + "static/media/PayrollDownloadArrow.61e2b80b.svg";